import { render, staticRenderFns } from "./FavoriteProjectButton.vue?vue&type=template&id=4a1bf6b5"
import script from "./FavoriteProjectButton.vue?vue&type=script&lang=ts"
export * from "./FavoriteProjectButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports